import { useTranslation } from 'react-i18next'
import { ReactComponent as Undo } from '../../../assets/svg/Undo.svg'
import InfiniteScroll from 'react-infinite-scroll-component'
import DailyResponse from '../../classroom/DailyResponse'
import PollTask from '../../PollTask'
import QuestionTask from '../../QuestionTask'
import Loading from '../../Loading'

const FeedbackHistoryView = ({ historyList, hasMore, loadingMore, studentName, onClose, onLoadNext }) => {
    const { t } = useTranslation()

    return (
        <div className="feedback-student-modal">
            <div className="feedback-modal-header" style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', background: '#5e639b' }}>
                <div className="history-back-button" onClick={onClose}>
                    <Undo style={{ color: '#BEBECE' }} />
                </div>
                <div className="history-header-title">
                    <p>{studentName}</p>
                    <p>{t('User activity')}</p>
                </div>
                <div className="history-back-button invisible" />
            </div>
            <div className="histrory-list-container">
                <div id="scrollableDiv" className="history-list-scroll light-small-scroll">
                    <div style={{ paddingRight: 15 }}>
                        <InfiniteScroll dataLength={historyList.length} next={onLoadNext} hasMore={hasMore} scrollableTarget="scrollableDiv">
                            {historyList.map(
                                (item, index) =>
                                    (item.content.type === 'daily' && <DailyResponse item={item} key={index} />) ||
                                    (item.content.type === 'poll' && <PollTask task={item} key={index} />) ||
                                    (item.content.type === 'question' && <QuestionTask task={item} key={index} />)
                            )}
                            {loadingMore && (
                                <div className="flex justify-center items-center mt-5 mb-5">
                                    <Loading />
                                </div>
                            )}
                        </InfiniteScroll>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default FeedbackHistoryView
